// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackCustomerChangedParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/account/trackCustomerChanged";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackCustomerChanged = (
    parameters: PartialSpecific<TrackCustomerChangedParameters, "fulfillment_method" | "set_as_default"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.customerChanged, parameters, options);
};

export default useTrackCustomerChanged;
